import 'css-chunksrc/client/scenes/inviteMembers/member/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_1vw44_1",
  "input": "_input_1vw44_5",
  "selection": "_selection_1vw44_18",
  "placeholder": "_placeholder_1vw44_24",
  "list": "_list_1vw44_29",
  "role": "_role_1vw44_1",
  "iconBox": "_iconBox_1vw44_56",
  "icon": "_icon_1vw44_56",
  "opened": "_opened_1vw44_66",
  "selectedRole": "_selectedRole_1vw44_74",
  "selectedRoleIcon": "_selectedRoleIcon_1vw44_78",
  "selectedRoleTitle": "_selectedRoleTitle_1vw44_84",
  "roleDescription": "_roleDescription_1vw44_91",
  "disabled": "_disabled_1vw44_96",
  "invalid": "_invalid_1vw44_103"
};